export default "/list/static/images/Wotif_BrandLogo.jpg";